import moment from "moment/moment";

export const subtractDays = (date: Date, days: number) => {
    date.setDate(date.getDate() - days);
    return date
}

export const formatIsoReadable = (text: string) => moment.utc(text).local().format("YYYY-MM-DD HH:mm:ss")